import App from "./app/App";

import { createRoot } from "react-dom/client";
const container = document.getElementById("root");
const root = createRoot(container!);

import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { appRoutes } from "./app-routes";
import { AuthProvider } from "./auth";
import { Auth0ProviderWrapper } from "./auth/auth0-provider-wrapper";
import { ErrorBoundary } from "./components/error-boundary";
import { mixpanelConfig } from "./lib/mixpanel/mixpanel-config";
import { MixpanelProvider } from "./lib/mixpanel/mixpanel-context";
import { ThemeProvider } from "./lib/theme-provider";
import { NotificationOpen } from "./pages/notifications/open";

function Root() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="system" storageKey="ua-dashboard-theme">
        <Auth0ProviderWrapper>
          <MixpanelProvider config={mixpanelConfig}>
            <AuthProvider>
              <App />
            </AuthProvider>
          </MixpanelProvider>
        </Auth0ProviderWrapper>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      ...appRoutes,
      {
        path: "notifications/:id/open",
        element: <NotificationOpen />,
        handle: { title: "", description: "", category: "team", skipHeader: true },
      },
    ],
  },
]);
root.render(<RouterProvider router={router} />);
